export function roundPrice (price){
  return Math.floor(100*price)/100
}